export const SIDEBAR_LAYOUT = {
  storageKey: 'sidebar-collapsed',
  expandedWidth: 280,
  collapsedWidth: 64,
  mobileBreakpointPx: 768,
} as const;

export type SidebarLayoutConfig = typeof SIDEBAR_LAYOUT;
